import { render, staticRenderFns } from "./BusinessPixelApproval.vue?vue&type=template&id=c23f7448&"
import script from "./BusinessPixelApproval.vue?vue&type=script&lang=js&"
export * from "./BusinessPixelApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports